module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-NLZRCT"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
